import { resCepApi } from "./model";
import { getCepApi } from "./service";

export async function getCEP(value: string, token: string): Promise<resCepApi> {
  const res: resCepApi = await getCepApi({
    cep: value,
    token,
  });
  return res;
}
